import logoToUse from "../../../assets/logoAFMF.png";

export const logo = logoToUse;
